import kanemaInstance from "../../services/kanemaInstance";

interface LoginCredentials {
    userid: string;
    password: string;
}

interface LoginResponse {
    success: boolean;
    accessToken?: string;
    refreshToken?: string;
    error?: string;
}

const authorizedEmails = [
    "noelmagulu4@gmail.com",
    "lkamangeni@icloud.com",
    "kamangenichikondi@gmail.com"
];

export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
    try {
        if (!authorizedEmails.includes(credentials.userid)) {
            return { success: false, error: 'Unauthorized' };
        }
        const response = await kanemaInstance.post(`/auth/login`, credentials, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        console.log("Login Response", response)

        if (response.data?.status === 'success' && response.data?.message?.tk) {
            const { accessToken, refreshToken } = response.data.message.tk;

            // Store tokens in localStorage
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            // Start the token refresh timer
            setupTokenRefresh();

            return {
                success: true,
                accessToken,
                refreshToken
            };
        }
        return { success: false, error: 'Invalid response from server' };
    } catch (error: any) {
        return {
            success: false,
            error: error.response?.data?.message || 'An unexpected error occurred during login'
        };
    }
};

// In services.ts
export const refreshAccessToken = async (): Promise<{ accessToken: string; refreshToken: string } | null> => {
    try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }

        console.log("Refreshing Token", refreshToken)

        const response = await kanemaInstance.get('/auth/refresh', {
            headers: {
                'Authorization': `Bearer ${refreshToken}`,
            },
        });

        console.log("Refresh Token Response", response)

        if (response.status === 200 && response.data?.message) {
            const { accessToken, refreshToken: newRefreshToken } = response.data.message;
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', newRefreshToken);
            return { accessToken, refreshToken: newRefreshToken };
        }
        return null;
    } catch (error) {
        // Clear tokens if refresh fails
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        return null;
    }
};


let refreshTokenTimer: NodeJS.Timeout;

export const startTokenRefreshTimer = () => {
    // Clear any existing timer
    if (refreshTokenTimer) {
        clearTimeout(refreshTokenTimer);
    }

    // Set a timer to refresh the token 1 minute before it expires
    const expiresIn = 2 * 60 * 1000; // 5 minutes
    const refreshTime = expiresIn - 60000; // Refresh 1 minute before expiration

    refreshTokenTimer = setTimeout(async () => {
        await refreshAccessToken();
        // Restart the timer for the new token
        startTokenRefreshTimer();
    }, refreshTime);
};

// Call this after successful login
export const setupTokenRefresh = () => {
    startTokenRefreshTimer();
};